import { render, staticRenderFns } from "./CertNew.vue?vue&type=template&id=67fd3cd2"
import script from "./CertNew.vue?vue&type=script&lang=js"
export * from "./CertNew.vue?vue&type=script&lang=js"
import style0 from "./CertNew.vue?vue&type=style&index=0&id=67fd3cd2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports